
import { useParams, useNavigate } from "react-router-dom";
import { useGprofileData } from "@/hooks/useGprofileData";
import GprofileLoading from "@/components/gprofile/GprofileLoading";
import GprofileError from "@/components/gprofile/GprofileError";
import GprofileNotFound from "@/components/gprofile/GprofileNotFound";
import GprofileContent from "@/components/gprofile/GprofileContent";
import AdPanel from "@/components/ads/AdPanel";

const Gprofile = () => {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const { profile, loading, error, refetch } = useGprofileData(userId);

  const handleBack = () => {
    console.log('🔙 Navigating back');
    navigate(-1);
  };

  if (loading) {
    return (
      <>
        <AdPanel />
        <GprofileLoading />
      </>
    );
  }

  if (error) {
    return (
      <>
        <AdPanel />
        <GprofileError 
          error={error}
          onRetry={refetch}
          onBack={handleBack}
        />
      </>
    );
  }

  if (!profile) {
    return (
      <>
        <AdPanel />
        <GprofileNotFound onBack={handleBack} />
      </>
    );
  }

  return (
    <>
      <AdPanel />
      <GprofileContent profile={profile} onBack={handleBack} />
    </>
  );
};

export default Gprofile;
